import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Beştelsiz Koltuk Yıkama", path: "/zeytinburnu/bestelsiz-koltuk-yikama" },
  { label: "Beştelsiz Yorgan Yıkama", path: "/zeytinburnu/bestelsiz-yorgan-yikama" },
  { label: "Merkezefendi Koltuk Yıkama", path: "/zeytinburnu/merkezefendi-koltuk-yikama" },
  { label: "Merkezefendi Perde Yıkama", path: "/zeytinburnu/merkezefendi-perde-yikama" },
  { label: "Telsiz Mahallesi Koltuk Yıkama", path: "/zeytinburnu/telsiz-koltuk-yikama" },
  { label: "Telsiz Mahallesi Battaniye Yıkama", path: "/zeytinburnu/telsiz-battaniye-yikama" },
  { label: "Yeşiltepe Koltuk Yıkama", path: "/zeytinburnu/yesiltepe-koltuk-yikama" },
  { label: "Yeşiltepe Kuru Temizleme", path: "/zeytinburnu/yesiltepe-kuru-temizleme" },
  { label: "Nuripaşa Koltuk Yıkama", path: "/zeytinburnu/nuripasa-koltuk-yikama" },
  { label: "Nuripaşa Yerinde Yıkama", path: "/zeytinburnu/nuripasa-yerinde-yikama" },
  { label: "Zeytinburnu Merkez Koltuk Yıkama", path: "/zeytinburnu/merkez-koltuk-yikama" }
];

const ZeytinburnuServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          ZEYTİNBURNU HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ZeytinburnuServiceArea;
